export const bulkMutate = (matcher, cache, mutate) => {
    if (!cache || !mutate || !(cache instanceof Map) || !(matcher instanceof RegExp)) {
        return Promise.resolve([]); // Ensure a consistent return of a Promise
    }

    // Collect keys that match the pattern
    const keys = Array.from(cache.keys()).filter((key) => matcher.test(key));

    // Mutate each key and gather promises
    const mutations = keys.map((key) => mutate(key));

    // Return a promise that resolves when all mutations are complete
    return Promise.all(mutations);
}
